import { EmployeeListComponent } from '../administrations/employees/employee.list';
import { EmployeeHttpService } from '../../services/http/administration/employee.http.service';
import { AdmCenterListComponent } from '../administrations/adm-centers/adm-center.list';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DivisionListComponent } from '../administrations/divisions/division.list';
import { RoomListComponent} from '../administrations/rooms/room.list';
import { RoomHttpService } from '../../services/http/administration/room.http.service';
import { DivisionHttpService } from '../../services/http/administration/division.http.service';
import { AdmCenterHttpService } from '../../services/http/administration/adm-center.http.service';
import { UserListComponent } from './user.list';
import { AssetEntityListComponent } from '../assets/assets/asset-entity.list';
import { IdentityService } from '../../services/http/identity/identity.service';
import { AssetHttpService } from '../../services/http/assets/asset.http.service';
import { Param } from '../../model/common/param';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NotificationService } from '../../services/notification.service';
import { DeviceList } from '../common/devices/device.list';
import { DeviceHttpService } from '../../services/http/common/device.http.service';

@Component({
    selector: 'identity-manage',
    templateUrl: 'identity.manage.html',
    styleUrls: ['identity.manage.scss'],
    providers: [ AdmCenterHttpService, EmployeeHttpService, DivisionHttpService, RoomHttpService ]
})
export class IdentityManage {

    @ViewChild('registerModal') registerModal: ModalDirective;
    @ViewChild('userList') userList: UserListComponent;


    public role: string = 'user';
    public filter: string = '';
    public model: any = {};
    public errorMessages: string[] = [];
    public errorMessage: string = '';
    isCollapsed: boolean = true;
    pageSize = 10;
    pageSizeTemp = 10;
    public allTemps: string = 'NO';

    @ViewChild('admCenterList') public admCenterList: AdmCenterListComponent;
    @ViewChild('admCenterListModal') public admCenterListModal: ModalDirective;
    @ViewChild('assetTempList') public assetTempList: AssetEntityListComponent;
    @ViewChild('assetTempListModal') public assetTempListModal: ModalDirective;
    @ViewChild('employeeList') public employeeList: EmployeeListComponent;
    @ViewChild('employeeListModal') public employeeListModal: ModalDirective;
    @ViewChild('roomList') public roomList: RoomListComponent;
    @ViewChild('roomListModal') public roomListModal: ModalDirective;
    @ViewChild('divisionList') public divisionList: DivisionListComponent;
    @ViewChild('divisionListModal') public divisionListModal: ModalDirective;
    @ViewChild('deviceList') public deviceList: DeviceList;
    @ViewChild('deviceListModal') public deviceListModal: ModalDirective;

    constructor(public router: Router,
                public identityHttpService: IdentityService,
                public identityService: IdentityService,
                public notificationService: NotificationService,
                public assetHttpService: AssetHttpService,
                public admCenterHttpService: AdmCenterHttpService,
                public divisionHttpService: DivisionHttpService,
                public roomHttpService: RoomHttpService,
                public deviceHttpService: DeviceHttpService,
                public employeeHttpService: EmployeeHttpService) {

    }

    ngAfterViewInit() {
        this.refreshUsers();
    }

    public changeRole(claimsValue: string) {
        if(this.userList.selectedItem != null){
            if (confirm('Modificati utilizatorul selectat?')) {
                this.identityService.updateUser(this.userList.selectedItem.userName, claimsValue)
                    .subscribe(() => {
                        this.refreshUsers();
                        this.notificationService.showSuccess('Actualizarea rolului s a finalizat cu success!', 'Modificare rol user');
                    });
            }
        }else {
            this.notificationService.showSuccess('Eroare actualizare date!', 'Modificare rol user');
        }
    }

    public refreshUsers() {
        let params: Array<Param> = new Array<Param>();
        params.push(new Param('filter', this.filter));
        params.push(new Param('role', this.role));

        this.userList.refresh(params);
    }

    public register() {
        // this.registerModal.show();
        this.router.navigate(['/register']);
    }

    public setSelectedRole(role: string) {
        this.role = role;
        this.refreshUsers();
    }
    public  changePassword(user: string) {
        this.router.navigate(['/passwordreset', user]);
    }
    public  deleteUser(user: string) {
        if (confirm('Stergeti utilizatorul selectat?')) {
            this.identityService.Delete(user)
                .subscribe(() => {
                   this.refreshUsers();
                    alert('Utilizatorul a fost sters.');
                });
        }
    }

    public selectAdmCenter() {
        this.admCenterListModal.show();
        this.admCenterList.refresh(null);
    }

    public setSelectedAdmCenter() {

        this.model.userId = this.userList.selectedItem.id;
        // this.model.admCenterId = this.admCenterList.selectedItem.id;

        if (this.admCenterList.selectedItems != null) {
            this.model.admCenterIds = new Array<number>();
            this.admCenterList.selectedItems.forEach((selectedItem) => {
                this.model.admCenterIds.push(selectedItem.id);
            });
        }



        this.identityService.UpdateUserAdmCenter(this.model)
            .subscribe(
            (res: any) => {
                // // IdentityResult.
                // if (res.succeeded) {
                //     // Signs in the user.
                //     this.router.navigate(['/identity']);
                // } else {
                //     this.errorMessages = res.errors;
                // }

                this.refreshUsers();

            },
            (error: any) => {

                // Error on post request.
                let errMsg = (error.message) ? error.message :
                    error.status ? `${error.status} - ${error.statusText}` : 'Server error';

                this.errorMessage = "Server error. Try later.";

            });

        this.admCenterListModal.hide();
    }

    public selectEmployee() {
        this.employeeListModal.show();
        this.employeeList.refresh(null);
    }

    public setSelectedEmployee() {
                this.model.userId = this.userList.selectedItem.id;
                this.model.employeeId = this.employeeList.selectedItem.id;

                this.identityService.UpdateUserEmployee(this.model)
                    .subscribe(
                    (res: any) => {
                        this.refreshUsers();
                    },
                    (error: any) => {
                        // Error on post request.
                        let errMsg = (error.message) ? error.message :
                            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        
                        this.errorMessage = "Server error. Try later.";
                    });
        
                this.employeeListModal.hide();
            }

            public selectRoom() {
                this.roomListModal.show();
                this.roomList.refresh(null);
            }
        
            public setSelectedRoom() {
                        this.model.userId = this.userList.selectedItem.id;
                        this.model.roomId = this.roomList.selectedItem.id;
        
                        this.identityService.UpdateUserRoom(this.model)
                            .subscribe(
                            (res: any) => {
                                this.refreshUsers();
                            },
                            (error: any) => {
                                // Error on post request.
                                let errMsg = (error.message) ? error.message :
                                    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
                
                                this.errorMessage = "Server error. Try later.";
                            });
                
                        this.roomListModal.hide();
                    }

            public selectDivision() {
                this.divisionListModal.show();
                this.divisionList.refresh(null);
            }
        
            public setSelectedDivision() {
                        this.model.userId = this.userList.selectedItem.id;
                        this.model.divisionId = this.divisionList.selectedItem.id;
        
                        this.identityService.UpdateUserDivision(this.model)
                            .subscribe(
                            (res: any) => {
                                this.refreshUsers();
                            },
                            (error: any) => {
                                // Error on post request.
                                let errMsg = (error.message) ? error.message :
                                    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
                
                                this.errorMessage = "Server error. Try later.";
                            });
                
                        this.divisionListModal.hide();
                    }
        


            public selectAssetTemp() {
                let selectedAssets = new Array<AssetEntityListComponent>();
                this.assetTempList.selectedItems = selectedAssets;
                
                this.assetTempListModal.show();
                this.assetTempList.refresh(null);
            }
        
            public setSelectedAssetTemp() {
        
                this.model.userId = this.userList.selectedItem.id;
        
                if (this.assetTempList.selectedItems != null) {
                    this.model.assetTempIds = new Array<number>();
                    this.assetTempList.selectedItems.forEach((selectedItem) => {
                        this.model.assetTempIds.push(selectedItem.id);
                    });
                }
        
        
        
                this.assetHttpService.mapAssetTemp(this.model)
                    .subscribe(
                    (res: any) => {
                        this.refreshUsers();
                    },
                    (error: any) => {
        
                        // Error on post request.
                        let errMsg = (error.message) ? error.message :
                            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        
                        this.errorMessage = "Server error. Try later.";
        
                    });
        
                this.assetTempListModal.hide();
            }

            public showAllTemps(){
                let params = new Array<Param>();

                if (this.allTemps === 'NO'){
                    this.allTemps = 'YES';
                }else {
                    this.allTemps = 'NO';
                }
            
                params.push(new Param('showAll', this.allTemps.toString()));
                params.push(new Param('companyCode', ''));
                this.assetTempList.refresh(params);
            }

            public showAllByCompanyTemps(code: string){

                let params = new Array<Param>();

                params.push(new Param('companyCode', code));
                this.assetTempList.refresh(params);
            }


            public selectDevice() {
                this.deviceListModal.show();
                this.deviceList.refresh(null);
            }
  
            public updateDevice(){
              if(confirm('Esti sigur ca vrei sa anulezi dispozitivul?')){
                  this.identityService.updateDevice(this.userList.selectedItem.id).subscribe((res) => {});
              }
  
              this.refreshUsers();
          }
  
  
          public setSelectedDevice() {
  
            this.model.userId = this.userList.selectedItem.id;
            this.model.deviceId = this.deviceList.selectedItem.id;
  
            this.identityService.UpdateUserDevice(this.model)
                .subscribe(
                (res: any) => {
                    // // IdentityResult.
                    // if (res.succeeded) {
                    //     // Signs in the user.
                    //     this.router.navigate(['/identity']);
                    // } else {
                    //     this.errorMessages = res.errors;
                    // }
  
                    this.refreshUsers();
  
                },
                (error: any) => {
  
                    // Error on post request.
                    let errMsg = (error.message) ? error.message :
                        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
  
                    this.errorMessage = 'Server error. Try later.';
  
                });
  
            this.deviceListModal.hide();
        }

        public onPageUpdate(number: number) {
            this.pageSize = number;
            this.refreshUsers();
        }


        public onPageTempUpdate(number: number) {
            this.pageSizeTemp = number;
            let params: Array<Param> = new Array<Param>();
            params.push(new Param('pageSize', this.pageSizeTemp.toString()));
            this.assetTempList.refresh(params);
        }
}